export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/shareholder-mizuho.31c1aabb-59015f.png";